class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    const newsletterPopupState = getCookie('newsletter-popup-state');

    this.closeButton = this.querySelector('[data-newsletter-popup-close]');
    this.form = this.querySelector('form');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }

    document.addEventListener('keydown', (event) => {
      if (event.keyCode !== 27) { return; }

      this.closePopup();
    });

    this.form.addEventListener('submit', () => {
      window.setCookie('newsletter-popup-state', 'submitted', 7);
    });

    if (Shopify.designMode && this.hasAttribute('data-test-mode')) {
      document.addEventListener('shopify:section:load', () => {
        this.openPopup();
      });
    }

    if (!newsletterPopupState) {
      setTimeout(() => {
        this.openPopup();
      }, 6000);
    }

    if (newsletterPopupState == 'submitted' && window.location.href.indexOf('#popup-signup') >= 0) {
      this.openPopup();
    }
  }

  openPopup() {
    this.classList.add('active');

    if (window.innerWidth >= 1025) {
      document.body.classList.add('overflow-hidden');
    } else {
      window.scrollLock();
    }

    setTimeout(() => {
      window.trapFocus(this);
    }, 100);
  }

  closePopup() {
    this.classList.remove('active');

    setCookie('newsletter-popup-state', 'closed', 7);

    if (window.innerWidth >= 1025) {
      document.body.classList.remove('overflow-hidden');
    } else {
      window.removeScrollLock();
    }

    window.removeTrapFocus();
  }
}

customElements.define('newsletter-popup', NewsletterPopup);

function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}

function setCookie(name, value, days) {
  document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * days}`;
}
